<template>
  <v-toolbar id="app_header" dark fixed app clipped-right>
    <v-toolbar-side-icon @click.stop="$emit('onTrigger')"></v-toolbar-side-icon>
    <v-spacer></v-spacer>
    <v-toolbar-title>
      <img
        :src="$store.state.theme.small_logo"
        class="responsive-img mt-2"
        style="max-height:35px;"
        alt
      />
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <lang-dropdown></lang-dropdown>
  </v-toolbar>
</template>

<style></style>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LangDropdown from '@/components/elements/LangDropdown'
export default {
  data() {
    return {
      showMenu: false,
      x: 0,
      y: 0,
      env: process.env.NODE_ENV,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ]
    }
  },
  components: {
    LangDropdown
  },
  mounted: function() {
    if (this.selectedBot == null) {
      this.$router.push('/' + this.currentLang + '/allbots')
    }
    var width = window.innerWidth
    if (width <= 768) {
      this.$store.state.openSidebar = false
    }
  },
  computed: {
    ...mapGetters({
      // selectedBot: 'selectedBot',
      isFacebook: 'isFacebook',
      botlist: 'botlist',
      isSelectedBot: 'isSelectedBot',
      currentLang: 'currentLang'
    }),
    selectedBot: {
      get() {
        if (this.$store.state.selectedBot == null) {
          return null
        }
        return this.$store.state.selectedBot
      },
      set(bot) {
        let vm = this
        vm.currentBot = bot
        vm.$store.dispatch('selectBot', vm.currentBot)
        location.reload()
      }
    }
  },
  methods: {
    show(e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    selectBot: function(pageid, event) {
      this.$store.dispatch('selectBot', pageid)
    },
    openSidebar: function() {
      this.$store.dispatch('sidebar')
    },
    onError: function() {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon {
  // line-height: 0 !important;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/header.vue